<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span>Contents</span></p>
<table cellpadding="8" cellspacing="3" width="150%">
<tbody><tr>
<td style="width:10%" valign="top"><a href="#/xhtml/chapter01"><span class="smallcaps">ONE</span></a></td>
<td style="width:90%" valign="top"><a href="#/xhtml/chapter01"><i>“Outremer”</i></a></td></tr>
<tr>
<td style="width:10%" valign="top"><a href="#/xhtml/chapter02"><span class="smallcaps">TWO</span></a></td>
<td style="width:90%" valign="top"><a href="#/xhtml/chapter02"><i>Macabru</i></a></td></tr>
<tr>
<td style="width:10%" valign="top"><span href="#/xhtml/chapter03" title="Link target outside of Sample"><span class="smallcaps">THREE</span></span></td>
<td style="width:90%" valign="top"><span href="#/xhtml/chapter03" title="Link target outside of Sample"><i>Sutcliffe, The Venetian Documents</i></span></td></tr>
<tr>
<td style="width:10%" valign="top"><span href="#/xhtml/chapter04" title="Link target outside of Sample"><span class="smallcaps">FOUR</span></span></td>
<td style="width:90%" valign="top"><span href="#/xhtml/chapter04" title="Link target outside of Sample"><i>Life with Toby</i></span></td></tr>
<tr>
<td style="width:10%" valign="top"><span href="#/xhtml/chapter05" title="Link target outside of Sample"><span class="smallcaps">FIVE</span></span></td>
<td style="width:90%" valign="top"><span href="#/xhtml/chapter05" title="Link target outside of Sample"><i>Dinner at Quartila’s</i></span></td></tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents1.vue?2ce11344